<template>
  <div>
    <hr />
  </div>
</template>

<script>
export default {
  name: "MobileSeparator"
};
</script>

<style lang="scss" scoped>
hr {
  margin: -10px $--gutter-landing-width / -2 0;
  height: 10px;
  display: none;
  border: none;
  border-bottom: 1px solid $--color-border;
  box-shadow: 0px 7px 9px 0px rgba(50, 50, 50, 0.1);
  @include media("<navbar-sm") {
    display: block;
  }
}
</style>
